(function() {

var w = window, d = document, prot = $.prototype;
w._ = _;
w.ui._ = _;

prot.append         = append;
prot.appendTo       = appendTo;
prot.attr           = attr;
prot.attrGet        = attrGet;
prot.attrR          = attrR;
prot.checked        = checked;
prot.css            = css;
prot.dispatch       = dispatch;
prot.html           = html;
prot.insert         = insert;
prot.off            = off;
prot.on             = on;
prot.options        = options;
prot.prepend        = prepend;
prot.remove         = remove;
prot.selected       = selected;
prot.scrollIntoView = scrollIntoView;
prot.swap           = swap;
prot.text           = text;
prot.textGet        = textGet;
prot.hasClass       = hasClass;
prot.toggleClass    = toggleClass;

prot.$elByClass     = $elByClass;
prot.elByClass      = elByClass;
prot.elsByClass     = elsByClass;
prot.$elByID        = $elByID;
prot.elByID         = elByID;
prot.elByTag        = elByTag;
prot.elsByTag       = elsByTag;
prot.parent         = parent;
prot.parentTo       = parentTo;

function _(obj, parent) {
  if(obj instanceof $)
    return obj;
  else
    return new $(obj, parent);
}

function $(obj, parent) {
  if((typeof obj === 'object') || (obj === undefined))
    this.el = obj;
  else
  if(obj === 'frag')
    this.el = d.createDocumentFragment();
  else
  if(obj.substr(0, 1) === '#')
    this.el = (parent || d).getElementById(obj.substr(1));
  else
  if(['svg', 'use'].indexOf(obj) !== -1)
    this.el = d.createElementNS('http://www.w3.org/2000/svg', obj);
  else
    this.el = d.createElement(obj);
}

function append() {
  if(this.el)
    for(var i = 0, l = arguments.length; i < l; i++)
      if(arguments[i] && arguments[i].el)
        this.el.appendChild(arguments[i].el);
  return this;
}

function appendTo($el) {
  $el.append(this);
  return this;
}

function assert(check, message) {
  if(!check)
    throw new Error(message || '');
}

function attr() {
  if(this.el)
    for(var i = 0, L = arguments.length; i < L; i += 2)
      this.el.setAttribute(arguments[i], arguments[i + 1]);
  return this;
}

function attrGet(name) {
  if(this.el)
    return this.el.getAttribute(name);
}

function attrR() {
  if(this.el)
    for(var i = 0, L = arguments.length; i < L; i++)
      this.el.removeAttribute(arguments[i]);
  return this;
}

function checked(checked) {
  if(this.el)
    this.el.checked = checked;
  return this;
}

function css(name, value) {
  if(this.el)
    this.el.style[name] = value;
  return this;
}

function $elByClass(className) {
  return _(this.elByClass(className));
}

function elByClass(className, raise) {
  var hes = this.elsByClass(className);
  if(hes.length === 0) {
    if(!raise && (raise !== undefined))
      return null;
  } else
  if(hes.length === 1)
    return hes[0];
  assert(false, '$.elByClass length: ' + hes.length + ' <> 1 by class name ' + className);
}

function elsByClass(className) {
  if(this.el)
    return this.el.getElementsByClassName(className);
  else
    return [];
}

function $elByID(id) {
  return _(this.elByID(id));
}

function elByID(id) {
  return this.el ? this.el.querySelector('#' + id) : null;
}

function elByTag(tagName) {
  var hes = this.elsByTag(tagName);
  assert(hes.length === 1, '$.elByTag length: ' + hes.length + ' <> 1 by tag name ' + tagName);
  return hes[0];
}

function elsByTag(tagName) {
  if(this.el)
    return this.el.getElementsByTagName(tagName);
  else
    return [];
}

function hasClass(className) {
  if(this.el)
    return this.el.classList.contains(className);
  return false;
}

function dispatch(name, bubbles) {
  if(this.el)
    this.el.dispatchEvent(new Event(name, {bubbles: bubbles}));
  return this;
}

function html(html) {
  if(this.el)
    this.el.innerHTML = html;
  return this;
}

function insert($el, $before) {
  if(this.el)
    this.el.insertBefore($el.el, $before ? $before.el : null);
  return this;
}

function off(name, func) {
  if(this.el)
    this.el.removeEventListener(name, func);
  return this;
}

function on(name, func, options) {
  if(this.el) {
    if(options === undefined)
      options = {'passive': true};
    this.el.addEventListener(name, func, options);
  }
  return this;
}

function options(datas, name, value, addEmpty) {
  if(addEmpty)
    this.append(_('option'));
  for(var i = 0; i < datas.length; i++)
    this.append(_('option').attr('value', datas[i][name]).text(datas[i][value]));
  return this;
}

function parent() {
  return _(this.el ? this.el.parentElement : null);
}

function parentTo(tagName) {
  tagName = tagName.toUpperCase();
  var el = this.el;
  while(el && (el.tagName.toUpperCase() !== tagName))
    el = el.parentElement;
  return _(el);
}

function prepend() {
  if(this.el)
    for(var i = 0, l = arguments.length; i < l; i++)
      this.el.prepend(arguments[i].el);
  return this;
}

function remove() {
  if(this.el)
    this.el.remove();
}

function selected(selected) {
  if(this.el)
    this.el.selected = selected;
  return this;
}

function scrollIntoView() {
  if(this.el)
    this.el.scrollIntoView();
}

function swap(down) {
  if(down)
    this.el.parentElement.insertBefore(this.el.nextSibling, this.el);
  else
    this.el.parentElement.insertBefore(this.el, this.el.previousSibling);
  return this;
}

function text(text, append = false) {
  if(this.el)
    if(append)
      this.el.appendChild(d.createTextNode(text));
    else
      this.el.textContent = text;
  return this;
}

function textGet() {
  if(this.el)
    return this.el.textContent;
}

function toggleClass(className, force) {
  if(this.el) {
    var names = className.split(' ');
    for(var i = 0; i < names.length; i++)
      this.el.classList.toggle(names[i], force);
  }
  return this;
}

})();